import type { FC } from "react";

import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import { ConnectButton } from "@rainbow-me/rainbowkit";

interface WalletDrawerProps {
	open?: boolean;
	// eslint-disable-next-line no-unused-vars
	toggleOpen: (val: boolean) => void;
}

const SwipeableTemporaryDrawer: FC<WalletDrawerProps> = ({
	open,
	toggleOpen,
}) => {
	return (
		<SwipeableDrawer
			anchor="bottom"
			open={open}
			onClose={() => toggleOpen(!open)}
			onOpen={() => toggleOpen(!open)}
			PaperProps={{
				sx: {
					borderTopLeftRadius: 8,
					borderTopRightRadius: 8,
				},
			}}
		>
			<Box
				sx={{
					":before": {
						backgroundColor: "rgba(255,255,255,0.5)",
						borderRadius: 20,
						content: `''`,
						height: 4,
						left: "calc(50% - 25px)",
						position: "absolute",
						top: 15,
						width: 50,
					},
				}}
			/>
			<Box display="flex" flexDirection="column" gap={2} padding={5}>
				<ConnectButton />
			</Box>
		</SwipeableDrawer>
	);
};

export default SwipeableTemporaryDrawer;
